<template>
    <section id="print">
        <div class="rowVar">
            <ul>
                <template v-for="(variety, index) in varieties">
                    <li v-for="q in +variety.agencyQuantity" class="variety varietyRow">
                        <div class="varietyContainer">
                            <div class="barcodeContainer">
                                <textarea
                                    rows="2"
                                    type="text"
                                    v-model="variety.product_title"
                                    class="varietyPrice"
                                ></textarea>
                                
                                <div v-for="item in variety.attributes" class="itemRow">
                                    <span class="varName">
                                        {{ item.pivot.value }}
                                    </span>
                                    <b>:{{ item.label }}</b>
                                </div>
                                
                                <!-- <div class="itemRow">
                                    <b>{{ checkLabel(item.key) }}</b>
                                    <span class="varName">
                                        {{ variety.title }}
                                    </span>
                                </div> -->

                                <barcode
                                    class="varietyBarcode"
                                    fontSize="12"
                                    width="1"
                                    marginBottom="0"
                                    :displayValue="true"
                                    height="25"
                                    :value="variety.id"
                                >
                                </barcode>

                                <span class="priceName">
                                    {{ formatPrice(variety.price) }} تومان  
                                </span>
                            </div>
                        </div>
                    </li>
                </template>
            </ul>
        </div>
        <button id="printBtn" @click="print">پرینت</button>
    </section>
</template>

<script>
import printVarietiesImpl from "@@/core/pages/Havale/HavaleBarcodeLmpl";
export default {
    extends: printVarietiesImpl,
};
</script>

<style src="@@/core/pages/printVarieties/printVarietiesStyle.css"></style>
